import React from 'react';
export function FooterSection() {
  return <footer className="bg-gray-900 text-gray-400 py-6 px-4 text-center text-xs md:text-sm border-t border-gray-800" data-id="element-48">
      <div className="max-w-3xl mx-auto space-y-3" data-id="element-49">
        <p data-id="element-50">
          © 2026 DescargaTop – Pack 100 Citas Todos los derechos reservados
        </p>
        <div className="flex justify-center gap-4" data-id="element-51">
          <a href="#" className="hover:text-white transition-colors" data-id="element-52">
            Privacidad
          </a>
          <span data-id="element-53">|</span>
          <a href="#" className="hover:text-white transition-colors" data-id="element-54">
            Términos y Condiciones
          </a>
        </div>
      </div>
    </footer>;
}